export const SET_QZ_CONNECTED = 'printers/qzConnected'
export const ADD_DELIVERYMEN = 'root/addDeliverymen'
export const REMOVE_DELIVERYMEN = 'root/removeDeliverymen'
